import badgesTemplates from './badgesTemplates';

import { Standard } from './badgesLayouts';
import { BADGE_COLORS } from 'elements/Badges/constants';

const badgesSet = [
  {
    component: Standard,
    codeTemplate: badgesTemplates.standard,
    optionsGroup: [
      {
        label: 'Black',
        options: [
          {label: 'Black', type: 'dropdown', selectList: [
            {label: 'Open', value: 'open', options: {children: 'open', color: BADGE_COLORS['black']}},
            {label: 'Not aplicable', value: 'not aplicable', options: {children: 'not aplicable', color: BADGE_COLORS['black']}}
          ]}
        ]
      }
    ]
  },
  {
    component: Standard,
    codeTemplate: badgesTemplates.standard,
    optionsGroup: [
      {
        label: 'Blue',
        options: [
          {label: 'Blue', type: 'dropdown', selectList: [
            {label: 'In progress', value: 'in progress', options: {children: 'in progress', color: BADGE_COLORS['blue']}},
            {label: 'Updated', value: 'updated', options: {children: 'updated', color: BADGE_COLORS['blue']}},
            {label: 'Live', value: 'live', options: {children: 'live', color: BADGE_COLORS['blue']}},
            {label: 'outstanding', value: 'outstanding', options: {children: 'outstanding', color: BADGE_COLORS['blue']}}
          ]}
        ]
      }
    ]
  },
  {
    component: Standard,
    codeTemplate: badgesTemplates.standard,
    optionsGroup: [
      {
        label: 'Green',
        options: [
          {label: 'Green', type: 'dropdown', selectList: [
            {label: 'Active', value: 'active', options: {children: 'active', color: BADGE_COLORS['green']}},
            {label: 'Ready', value: 'ready', options: {children: 'ready', color: BADGE_COLORS['green']}},
            {label: 'Paid', value: 'paid', options: {children: 'paid', color: BADGE_COLORS['green']}},
            {label: 'Closed', value: 'closed', options: {children: 'closed', color: BADGE_COLORS['green']}},
            {label: 'Completed', value: 'completed', options: {children: 'completed', color: BADGE_COLORS['green']}},
            {label: 'Invited', value: 'invited', options: {children: 'invited', color: BADGE_COLORS['green']}}
          ]}
        ]
      }
    ]
  },
  {
    component: Standard,
    codeTemplate: badgesTemplates.standard,
    optionsGroup: [
      {
        label: 'Orange',
        options: [
          {label: 'Orange', type: 'dropdown', selectList: [
            {label: 'Pending', value: 'pending', options: {children: 'pending', color: BADGE_COLORS['orange']}},
            {label: 'Tds pending', value: 'tds pending', options: {children: 'tds pending', color: BADGE_COLORS['orange']}},
            {label: 'Tds validation', value: 'tds validation', options: {children: 'tds validation', color: BADGE_COLORS['orange']}},
            {label: 'under review', value: 'under review', options: {children: 'under review', color: BADGE_COLORS['orange']}}
          ]}
        ]
      }
    ]
  },
  {
    component: Standard,
    codeTemplate: badgesTemplates.standard,
    optionsGroup: [
      {
        label: 'Purple',
        options: [
          {label: 'Purple', type: 'dropdown', selectList: [
            {label: 'Admin', value: 'admin', options: {children: 'admin', color: BADGE_COLORS['purple']}},
            {label: 'Guest', value: 'guest', options: {children: 'guest', color: BADGE_COLORS['purple']}},
            {label: 'Monitor', value: 'monitor', options: {children: 'monitor', color: BADGE_COLORS['purple']}},
            {label: 'Sub-admin', value: 'sub-admin', options: {children: 'sub-admin', color: BADGE_COLORS['purple']}},
            {label: 'Trader', value: 'trader', options: {children: 'trader', color: BADGE_COLORS['purple']}}
          ]}
        ]
      }
    ]
  },
  {
    component: Standard,
    codeTemplate: badgesTemplates.standard,
    optionsGroup: [
      {
        label: 'Red',
        options: [
          {label: 'Red', type: 'dropdown', selectList: [
            {label: 'Overdue', value: 'overdue', options: {children: 'overdue', color: BADGE_COLORS['red']}},
            {label: 'Expired', value: 'expired', options: {children: 'expired', color: BADGE_COLORS['red']}},
            {label: 'Rejected', value: 'rejected', options: {children: 'rejected', color: BADGE_COLORS['red']}},
            {label: 'Inactive', value: 'inactive', options: {children: 'inactive', color: BADGE_COLORS['red']}},
            {label: 'Deprecated', value: 'deprecated', options: {children: 'deprecated', color: BADGE_COLORS['red']}}
          ]}
        ]
      }
    ]
  }
];

export default badgesSet;



// WEBPACK FOOTER //
// ./src/containers/elements/Badges/constants/badgesSet.js